import React, { Component } from 'react';
import { i18nIntl, importCSS } from '../lib/ep.js';
import { injectIntl } from 'react-intl';
import { Motion, spring } from 'react-motion';

class QuizMonitor extends Component {
	constructor(props) {
		super(props);
		this.state = {
			odds:{
				_1:(100 / 3),	//w
				_x:(100 / 3),	//t
				_2:(100 / 3),	//l
			},
			results:[],
			unique:{},
			paginating:false,
			top:0,
		}

		this.prediction_module_height = window.innerHeight * 0.06;
		this.prediction_module_separation = window.innerHeight * 0.02;
		this.predictions_per_page = 8;
		this.page_actual = 0;
		this.total_pages = 1;
	}

	componentWillMount() {
		importCSS('comp/projection_match.css');
	}

	componentDidMount() {
		window.QuizMonitor = this;

		//Fetch current results from the quiz
		$.get('/promotions/quizmonitor/' + this.props.promotion_id + '/data', (res) => {
			this.setState({results:res});
		}, 'json');
	}

	addResult = (result) => {
		if(result != 'random') {
			this.setState({ results:this.state.results.concat(result) });
			return;
		}

		//Generate a random result
		let rand = Math.floor(Math.random() * 5);
		let rand2 = Math.floor(Math.random() * 5);

		let data = {};

		let first = this.props.questions[0].Answer[0];
		let second = this.props.questions[0].Answer[1];

		data[first.question_id] = {};
		data[first.question_id][first.id] = rand;
		data[first.question_id][second.id] = rand2;

		this.setState({ results:this.state.results.concat(data) });
	}

	pagination = () => {
		this.page_actual = (this.page_actual < this.total_pages - 1) ? this.page_actual + 1 : 0;
		this.setState({ top:(this.page_actual * (this.prediction_module_height + this.prediction_module_separation) * this.predictions_per_page) });
	}

	startPaginating = () => {
		this.state.paginating = true;
		this.timer = setInterval(this.pagination, (15 * 1000));
	}

	compute = () => {
		let unique = {};
		let qid = this.props.questions[0].Question.id;
		let first = this.props.questions[0].Answer[0].id;
		let second = this.props.questions[0].Answer[1].id;

		this.odds = {
			_1:0,
			_x:0,
			_2:0,
		};

		for(var i in this.state.results) {
			let w = this.state.results[i][qid][first];
			let l = this.state.results[i][qid][second];
			let k = w + '-' + l;

			if(unique[k] == undefined) unique[k] = 0;
			unique[k]++;

			if(parseInt(w) > parseInt(l)) {
				this.odds._1++;
			} else if(parseInt(w) < parseInt(l)) {
				this.odds._2++;
			} else {
				this.odds._x++;
			}
		}

		let count = this.state.results.length;
		if(count == 0) {
			this.odds = {
				_1:(100 / 3),
				_x:(100 / 3),
				_2:(100 / 3),
			};
		} else {
			this.odds._1 = (this.odds._1 / count) * 100;
			this.odds._x = (this.odds._x / count) * 100;
			this.odds._2 = (this.odds._2 / count) * 100;
		}

		var sorted = Object.keys(unique).map(i => ({ result:i, count:unique[i] })).sort((a, b) => {
			if(a.count == b.count) return (a.result < b.result) ? 1 : -1;
			return (a.count < b.count) ? 1 : -1;
		});

		var positions = {};
		for(var i in sorted) {
			positions[sorted[i].result] = i;
		}

		var res = { results:Object.keys(unique).map(i => ({ result:i, count:unique[i], pos:positions[i] })), odds:this.odds };

		this.total_pages = Math.ceil(res.results.length / this.predictions_per_page);

		if(this.total_pages > 1 && !this.state.paginating) {
			this.startPaginating();
		}

		return res;
	}

	render() {
		const i18n = (m, c) => i18nIntl(m, this.props.intl, c);

		const answers = this.props.questions[0].Answer;

		const comp = this.compute();
		const results = comp.results;
		const odds = comp.odds;

		const min_height_odd_display = 100 / 5;
		const max_height_odd_display = 100 / 3;
		const odds_total = odds._1 + odds._x + odds._2;

		const max_odd = Math.max(odds._1 / odds_total, odds._x / odds_total, odds._2 / odds_total);

		const odds_proportional = {
			_1:min_height_odd_display + (max_height_odd_display - min_height_odd_display) * (odds._1 / odds_total) / max_odd,
			_x:min_height_odd_display + (max_height_odd_display - min_height_odd_display) * (odds._x / odds_total) / max_odd,
			_2:min_height_odd_display + (max_height_odd_display - min_height_odd_display) * (odds._2 / odds_total) / max_odd,
		};

		const integration = (this.props.integration != undefined) ? this.props.integration : false;
		if(!integration) return null;
		const integration_config = (integration.config != undefined) ? integration.config : false;
		if(!integration_config) return null;

		/* DATA FROM INTEGRATION - ini */
		const bg_color = (integration_config.background != undefined) ? integration_config.background : '#000048';
		const local_color = (integration_config.local_color != undefined) ? integration_config.local_color : 'rgba(115, 0, 47, 1)';
		const visitor_color = (integration_config.visitor_color != undefined) ? integration_config.visitor_color : 'rgba(0, 113, 105, 1)';
		const title = (integration_config.title != undefined) ? integration_config.title : i18n("Your predictions for the match");
		const date = (integration_config.date != undefined) ? EPDate(integration_config.date) : EPDate();
		const room = (integration_config.room != undefined) ? integration_config.room : i18n("Room") + ' #1';
		/* DATA FROM INTEGRATION - end */

		const tie_color = 'rgba(255, 255, 255, 0.2)';
		const max_width = 30; // vw
		const min_width = 10; // vw
		const interval_width = (max_width - min_width) / results.length;


		const header = (integration.config != undefined && integration.config.full_header != undefined) ? {backgroundImage:'url(' +integration.config.full_header + ')'} : {};

		return (
			<div class="gui_projection_match is_fullscreen awesome" style={{background:bg_color}}>
				<header class="projection_header" style={header}>
					<h2 class="title textual">{title}</h2>
					<div class="room_info">
						<span class="date">{date.format('DD-MM-YYYY')}</span>
						<span class="room">{room}</span>
					</div>
				</header>
				<section class="projection_contents">
					<article class="gui_flexbox gui_flex_col gui_flex_nowrap">
						<article class="proj_section">
							<h3 class="section_title textual">{i18n("Winner predictions")}</h3>
							<div class="conts match_teams">
								<div class="vs gui_pos_rel">
									<div>
										{/*<span class="color_legend is_local" style={{background:local_color}}></span>*/}
										<h4 class="team_name">{i18n("vs")}</h4>
										{/*<span class="color_legend is_visitor" style={{background:visitor_color}}></span>*/}
									</div>
								</div>
								{answers.map((a, i) => {
									return (
										<div key={'a' + i}>
											<div class="logo" style={{backgroundImage:'url(' + a.fullimage + ')'}}><img src={window.cdn_url + 'img/blank_1x1.png'} height="100%" /></div>
											<h4 class="team_name">{a.answer}</h4>
										</div>
									)
								})}
							</div>

							{/*<h3 class="section_title textual">{i18n("Winner predictions")}</h3>*/}
							<div class="conts winner_predictions">
								<div class="winner_predictions_stats">
									<Motion defaultStyle={{w:odds_proportional._1}} style={{w:spring(odds_proportional._1, { stiffness:300, damping:40 })}}>
										{(style) => (
											<div style={{flexBasis:style.w+'%'}}>
												<div class="circled_counter">
													<div class="info" style={{fontSize:'calc(15svh * ' + (odds_proportional._1 / 100) + ')'}}>{Math.round(10 * odds._1) / 10}%</div>
													<div class="legend" style={{background:local_color}}><span style={{fontSize:'calc(11svh * ' + (odds_proportional._1 / 100) + ')'}}>1</span></div>
													<img src={window.cdn_url + 'img/blank_1x1.png'} width="100%" />
												</div>
											</div>
										)}
									</Motion>

									<Motion defaultStyle={{w:odds_proportional._x}} style={{w:spring(odds_proportional._x, { stiffness:300, damping:40 })}}>
										{style => (
											<div style={{flexBasis:style.w+'%'}}>
												<div class="circled_counter">
													<div class="info" style={{fontSize:'calc(15svh * ' + (odds_proportional._x / 100) + ')'}}>{Math.round(10 * odds._x) / 10}%</div>
													<div class="legend" style={{background:tie_color}}><span style={{fontSize:'calc(11svh * ' + (odds_proportional._x / 100) + ')'}}>X</span></div>
													<img src={window.cdn_url + 'img/blank_1x1.png'} width="100%" />
												</div>
											</div>
										)
									}
									</Motion>

									<Motion defaultStyle={{w:odds_proportional._2}} style={{w:spring(odds_proportional._2, { stiffness:300, damping:40 })}}>
										{(style) => (
											<div style={{flexBasis:style.w+'%'}}>
												<div class="circled_counter">
													<div class="info" style={{fontSize:'calc(15svh * ' + (odds_proportional._2 / 100) + ')'}}>{Math.round(10 * odds._2) / 10}%</div>
													<div class="legend" style={{background:visitor_color}}><span style={{fontSize:'calc(11svh * ' + (odds_proportional._2 / 100) + ')'}}>2</span></div>
													<img src={window.cdn_url + 'img/blank_1x1.png'} width="100%" />
												</div>
											</div>
										)}
									</Motion>
								</div>

								{/*<div class="teams_legend">
									{answers.map((a, i) => {
										return (
											<div key={'a' + i}>
												<h4 class="team_name">{a.answer}</h4>
											</div>
										)
									})}
								</div>*/}
							</div>
						</article>
					</article>

					<article class="gui_flexbox gui_flex_col gui_flex_nowrap">
						<article class="proj_section gui_flex_space_between">
							<h3 class="section_title textual">{i18n("Score predictions")}</h3>

							<div class="conts score_predictions" style={{flexBasis:'calc(' + ((this.prediction_module_height + this.prediction_module_separation) * this.predictions_per_page - this.prediction_module_separation) + 'px + 6svh)', flexGrow:'0'}}>

								<div class="teams_legend">
									{answers.map((a, i) => {
										return (
											<div key={'a' + i}>
												<h4 class="team_name">{a.answer}</h4>
											</div>
										)
									})}
								</div>

								<div class="score_predictions_stats">
									<Motion defaultStyle={{x:0}} style={{x:spring(this.state.top, { stiffness:150, damping:40 })}}>
										{(style) => (
											<ul style={{top:`-${style.x}px`}}>
												{results.map((res, i) => {
													const style = { x:spring((res.pos * (this.prediction_module_height + this.prediction_module_separation)), { stiffness:300, damping:40 }) };

													const this_width = min_width + interval_width * (results.length - res.pos);
													const stylePercent = { x:spring(this_width, { stiffness:300, damping:40 }) };

													const score_prediction = res.result.split("-");
													const percent = 100 * res.count / this.state.results.length;

													var status_bg = tie_color;
													if(score_prediction[0] > score_prediction[1]) status_bg = local_color;
													if(score_prediction[0] < score_prediction[1]) status_bg = visitor_color;

													return (
														<Motion key={i} defaultStyle={{x:window.innerHeight}} style={style}>
															{style => {
																return (
																	<li id={res.result} style={{top:`${style.x}px`}}>
																		<div>
																			<span class="local" style={{background:status_bg}}>{score_prediction[0]}</span>
																			<Motion defaultStyle={{x:30}} style={stylePercent}>
																				{style => {
																					return (
																						<span class="percent" style={{background:status_bg, width:`${style.x}vw`}}>{Math.round(10 * percent) / 10}%</span>
																					)
																				}}
																			</Motion>
																			<span class="visitor" style={{background:status_bg}}>{score_prediction[1]}</span>
																		</div>
																	</li>
																)
															}}
														</Motion>
													)}
												)}
											</ul>
										)}
									</Motion>
								</div>
							</div>
						</article>
					</article>
				</section>
			</div>
		)
	}
}

export default injectIntl(QuizMonitor);